export const projects = [
  {
    id: 'paw',
    title: 'PAW',
    generation: 14,
    year: 2026,
    description: '반려동물 AI 진료요약 및 건강관리 앱',
    category: ['App'],
    github: 'https://github.com/GaGuRacZi',
    tags: ['Spring', 'React Native', 'Open AI'],
  },
  {
    id: 'mcm-lounge',
    title: 'MCM Lounge',
    generation: 14,
    year: 2026,
    description: '첫 접점부터 확신까지, 새로운 럭셔리 여정 웹 서비스',
    category: ['Web'],
    github: 'https://github.com/Binteum-14',
    tags: ['React', 'Java', 'Spring'],
  },
  {
    id: 'todays-casting',
    title: "Today's Casting",
    generation: 14,
    year: 2026,
    description: '하루를 기록하면 AI가 어울리는 배역을 캐스팅해 주는 앱',
    category: ['App'],
    github: 'https://github.com/todays-casting',
    tags: ['React Native', 'Spring Boot', 'AWS'],
  },
  {
    id: 'contextory',
    title: 'Contextory',
    generation: 14,
    year: 2026,
    description: 'AI 기반 GitHub PR 분석 및 기록 관리 서비스',
    category: ['Web'],
    github: 'https://github.com/kau-likelion-14th-hackathon',
    tags: ['Spring Boot', 'FastAPI', 'PostgreSQL'],
  },
  {
    id: 'hidaddy',
    title: '하이대디',
    generation: 13,
    year: 2025,
    description: '아빠들을 위한 임신 동행 애플리케이션',
    category: ['App'],
    github: 'https://github.com/Devroup',
    tags: ['React Native', 'Java'],
  },
    {
    id: 'princesslibrary',
    title: 'Princess Library',
    generation: 13,
    year: 2025,
    description: 'AI 기반 독서록, 독서 토론 웹 서비스',
    category: ['Web'],
    github: 'https://github.com/Team-Fwaiya/Frontend-Princess',
    tags: ['React', 'Java', 'Spring'],
  },
  {
    id: 'classfit',
    title: '클래스핏(class+fit)',
    generation: 13,
    year: 2025,
    description: 'AI 기반 수강신청 지원 웹 서비스',
    category: ['Web'],
    github: 'https://github.com/Zsun3011/classfit',
    tags: ['React', 'Spring Boot', 'AWS'],
  },
  {
    id: 'ibsi',
    title: '입시혁명',
    generation: 13,
    year: 2025,
    description: 'AI 기반 입시 도우미',
    category: ['Web'],
    github: 'https://github.com/gotothesky2',
    tags: ['React', 'Spring Boot', 'Open API(CaarerNet)'],
  },
   {
    id: 'woowang',
    title: '우리따라왕',
    generation: 12,
    year: 2024,
    description: '여행 코스 추천 웹 서비스',
    category: ['Web'],
    github: 'https://github.com/kau-likelion-12th/WooWang-fe.git',
    tags: ['HTML', 'CSS', 'JavaScript', 'Java'],
  },
  {
    id: 'mutcycle',
    title: '멋사이클링',
    generation: 12,
    year: 2024,
    description: '웹 기반 프로젝트',
    category: ['Web'],
    github: 'https://github.com/kau-likelion-12th/mutcycle.git',
    tags: ['HTML', 'JavaScript', 'Java'],
  },
  {
    id: 'babywithus',
    title: '우리랑 아기랑',
    generation: 12,
    year: 2024,
    description: '초보 부모들을 위한 임신 동행 웹 서비스',
    category: ['Web'],
    github: 'https://github.com/kau-likelion-12th/BabyWithUs-fe.git',
    tags: ['HTML', 'CSS', 'JavaScript', 'Java'],
  },
];

export const getProjectsByGeneration = (gen) =>
  projects.filter(p => p.generation === gen);

export const getProjectsByCategory = (category) =>
  projects.filter(p => p.category.includes(category));
